import React from "react"
import CoreZoneLayer from "@/features/gis/CoreZoneLayer.jsx"

const rows = (p) => [
  p.name && [null, p.name],
  Array.isArray(p.pollutants) && p.pollutants.length && ["Pollutants", p.pollutants.join(", ")],
  p.status && ["Status", p.status],
  p.authority && ["Authority", p.authority],
]

export default function Eca(props) {
  return (
    <CoreZoneLayer
      flag="ECA"
      path="eca"
      title="ECA Area"
      style={{ fillColor: "green", color: "green", weight: 2 }}
      rows={rows}
      {...props}
    />
  )
}
